import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import authService from '../../services/authService';
import styles from './AdminLoginPage.module.scss';
import { toast } from 'react-toastify';
// Import các icon để giao diện đẹp hơn
import { IoPersonOutline, IoLockClosedOutline, IoArrowBack, IoLeafOutline } from 'react-icons/io5';

const AdminLoginPage = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    authService.adminLogin(username, password)
      .then(response => {
        setLoading(false);
        sessionStorage.setItem('adminToken', response.data.token);
        navigate('/admin/dashboard'); 
        toast.success('Xin chào quản trị viên!');
      })
      .catch(err => {
        setLoading(false);
        if (err.response && err.response.data) {
          setError(err.response.data.message);
        } else {
          setError('Không thể kết nối đến máy chủ.');
        }
      });
  };

  return (
    <div className={styles.loginPage}>
      {/* Nút quay lại trang chủ nằm góc trên */}
      <Link to="/" className={styles.backHomeBtn}>
        <IoArrowBack /> Về trang chủ
      </Link>

      <div className={styles.loginCard}>
        <div className={styles.brandHeader}>
          <IoLeafOutline className={styles.brandIcon} />
          <h2>An Nhiên Trầm</h2>
          <p>Hệ thống quản trị</p>
        </div>
        
        <form className={styles.loginForm} onSubmit={handleSubmit}>
          {error && <div className={styles.errorMessage}>{error}</div>}

          <div className={styles.inputGroup}>
            <label htmlFor="username">Tên đăng nhập</label>
            <div className={styles.inputWrapper}>
              <IoPersonOutline className={styles.inputIcon} />
              <input
                type="text"
                id="username"
                placeholder="Nhập username..."
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                required
              />
            </div>
          </div>

          <div className={styles.inputGroup}>
            <label htmlFor="password">Mật khẩu</label>
            <div className={styles.inputWrapper}>
              <IoLockClosedOutline className={styles.inputIcon} />
              <input
                type="password"
                id="password"
                placeholder="Nhập mật khẩu..."
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
            </div>
          </div>

          <button type="submit" className={styles.loginButton} disabled={loading}>
            {loading ? <span className={styles.loader}></span> : 'Đăng Nhập Hệ Thống'}
          </button>
        </form>
        
        <div className={styles.cardFooter}>
           &copy; {new Date().getFullYear()} An Nhien Tram Admin Panel
        </div>
      </div>
    </div>
  );
};

export default AdminLoginPage;